import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      step: "1",
      title: "注册账户",
      description: "创建免费账户，开始使用简历匹配度评估服务"
    },
    {
      step: "2", 
      title: "设置心仪岗位",
      description: "添加目标职位描述，明确岗位要求和评估标准"
    },
    {
      step: "3",
      title: "上传候选人简历",
      description: "上传简历文件，系统自动解析简历内容和关键信息"
    },
    {
      step: "4",
      title: "获取匹配度报告",
      description: "系统分析简历与岗位的匹配程度，生成详细评估报告"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            使用流程
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            简单四步，即可获得专业的简历与岗位匹配度评估结果
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                {step.step}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;